import type { MouseEvent, ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

import { CloseIcon } from '../../images/shapes';

import Button from '../Button/Button';

interface AnnouncementComponentProps {
  /**
   * Has close button
   */
  hasCloseButton?: boolean;
  /**
   * Additional classes for pagination box
   */
  additionalClasses?: string;
  /**
   * Component test id
   */
  testId?: string;
  /**
   * Hide component
   */
  hidden?: boolean;
  /**
   * Announcement to display
   */
  announcement?: ReactNode;
  /**
   * Handle Close button
   */
  handleClose?: (e: MouseEvent<HTMLButtonElement>) => void;
}

const AnnouncementComponent = ({
  additionalClasses = '',
  announcement = '',
  handleClose,
  hidden = false,
  hasCloseButton = false,
  testId = '',
}: AnnouncementComponentProps) => {
  if (!announcement) return null;

  return (
    <div
      className={twMerge(
        'flex w-full justify-center items-center fixed z-40 bg-gradient-featured-bar',
        hidden && 'hidden',
        additionalClasses,
      )}
      {...getTestProps(testId, 'container')}
    >
      {typeof announcement === 'string' ? (
        <div
          className="w-full pr-10 lg:pr-12"
          dangerouslySetInnerHTML={{
            __html: announcement,
          }}
        />
      ) : (
        announcement
      )}

      {hasCloseButton && (
        <div
          className={twMerge(
            'flex items-center h-full',
            'absolute top-0 right-0 w-10 lg:w-12',
          )}
        >
          <Button
            iconImage={
              <CloseIcon className="text-white group-hover/button:opacity-50 w-4 lg:w-5" />
            }
            buttonColor="borderless"
            buttonSize="md"
            onClick={handleClose}
            additionalIconClasses="m-2"
            {...getTestProps(testId, 'close-button-announcement', 'testId')}
          />
        </div>
      )}
    </div>
  );
};

export default AnnouncementComponent;
